module.exports = __webpack_public_path__ + "img/场租发票示例.926c5add.png";